module.exports = __webpack_public_path__ + "img/bg_client.e28e0dc8.png";